export default {"src":"/_next/static/media/osome_logo.c557cef6.svg","height":89,"width":256,"blurWidth":0,"blurHeight":0};